import { $get } from "@/utils/request";
import { WithdrawInfoParams } from '@/interface/withdraw';

// 提现记录详情
export const getWithdrawInfo = (params: WithdrawInfoParams) => {
  return $get(`/v1/user/withdraw/info`, params).then((res: any) => res.data)
}
